import { useTranslation } from "react-i18next";
import { Badge, type BadgeVariantProps } from "@/shared/components/ui/badge";
import type { InvitationStatus } from "./types";

type Variant = NonNullable<BadgeVariantProps["variant"]>;

/** Exhaustive: adding a status to the type without a colour here fails typecheck. */
const VARIANT = {
  PENDING: "warning",
  ACCEPTED: "success",
  DECLINED: "secondary",
  EXPIRED: "secondary",
  REVOKED: "secondary",
  SEND_FAILED: "danger",
} as const satisfies Record<InvitationStatus, Variant>;

/** A status this build does not know yet (the API moved first) still gets a neutral badge. */
const UNKNOWN_VARIANT: Variant = "secondary";

interface InvitationStatusBadgeProps {
  readonly status: InvitationStatus;
  readonly testId?: string;
}

export function InvitationStatusBadge({ status, testId }: InvitationStatusBadgeProps) {
  const { t } = useTranslation();
  const key = `invitations.status.${status}`;
  const variant: Variant = status in VARIANT ? VARIANT[status] : UNKNOWN_VARIANT;
  return (
    <Badge variant={variant} data-testid={testId}>
      {t(key, { defaultValue: status })}
    </Badge>
  );
}
